/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import AppsAssignConnection from 'DesignSystem/AppsAssignConnection/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/Tabs/Apps/Content/Launchers/Content/App/AssignConnection/Content"
  
}) {
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let tabPatientIdValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'patient_id',
})
let globalCurrentLocationIdValueData = fromData.useDataValue({ viewPath,
context: 'global',
path: 'current_location._id',
})
let componentAppIdValueData = fromData.useDataValue({ viewPath,
context: 'component',
path: 'app_id',
})
let appShortNameValueData = fromData.useDataValue({ viewPath,
context: 'app',
path: 'shortName',
})
let componentOnSubmitValueData = fromData.useDataValue({ viewPath,
context: 'component',
path: 'onSubmit',
})
  return (<React.Fragment
>
<AppsAssignConnection
  viewPath={`${viewPath}/AppsAssignConnection`}
 data="tab.patient_id"
 patientId={tabPatientIdValueData}
 data="global.current_location._id"
 locationId={globalCurrentLocationIdValueData}
 data="component.app_id"
 appId={componentAppIdValueData}
 data="app.shortName"
 appName={appShortNameValueData}
 onClose={() => setFlowTo(fromFlow.normalizePath(viewPath, '../No'))}
 data="component.onSubmit"
 onSubmit={componentOnSubmitValueData}
/>
{children}
</React.Fragment>)
}